import styles from '@activities/gift/GiftSentActivity/components/RefundButton/styles.module.scss';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { useFlow } from '@router/stackflow';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

const GiftCanceledModal: ActivityComponentType = () => {
    const { pop } = useFlow();
    const { t } = useTranslation('gift');
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth spacing={32}>
                    <Column fullWidth align='center'>
                        <Text size='3xl' fontWeight='bold'
                            className={styles.title}>
                            {t('giftCanceledModal.title')}
                        </Text>
                        <Text size='xl' align='center'>
                            {t('giftCanceledModal.description')}
                        </Text>
                    </Column>
                    <Button fullWidth onClick={pop}>
                        {t('giftCanceledModal.confirm')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default GiftCanceledModal;
